import "../../sass/layout/articleListContainer/articleListContainer.css";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { usePath } from "../../hooks/usePath";
import imgPlaceholder from "../../utils/img/imgPlaceholder.png";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const ArticlePreviewList = ({ border, article }) => {
  const tokenMedia = useSelector((state) => state.homeReducer.tokenMedia);
  const navigate = useNavigate();
  const path = usePath();
  const { t } = useTranslation();
  const id = useSelector(
    (state) => state.homeReducer.location?.data
  )?.uniqueNonGuessableId;

    const truncateAfterWord = (str, chars, placeholder = '…') =>  
    {
      if(!str) return ''
      return str?.length < chars ? str : `${str?.substr( 0, str?.substr(0, chars - placeholder?.length).lastIndexOf(" "))}${placeholder}`;

    }

  const articleContent = truncateAfterWord(
    article?.attributes?.body,
    400
  )

  return (
    <Container fluid className="no-border-container">
      <Row className={border ? "article-item-border" : "article-item"}>
        <Col lg={5} md={5} sm={12} xs={12}>
          <div
            style={{
              height: "15rem",
              width: "100%",
              backgroundRepeat: "no-repeat",
              backgroundPositionX: "center",
              backgroundPositionY: "center",
              backgroundSize: "cover",
              backgroundImage: article?.attributes?.image?.data?.attributes?.url
                ? `url(${
                    article?.attributes?.image?.data?.attributes?.url +
                    "?" +
                    tokenMedia
                  })`
                : `url(${imgPlaceholder})`,
            }}
          ></div>
        </Col>
        <Col className="text">
          <h4>{article?.attributes?.title}</h4>
         <ReactMarkdown 
            className="description" 
            remarkPlugins={[remarkGfm]} 
            components={{
              table: ({node, ...props}) => <table className="table table-bordered table-striped" {...props} />
            }}
            children={articleContent} 
          />
          <div
            className="seeArticle"
            onClick={() => {
              id !== "/" && navigate(`/${path}/article/${article?.id}`);
              id === "/" && navigate(`/article/${article?.id}`);
            }}
          >
            {t("article.seeThisArticle")}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ArticlePreviewList;
